<template>
  <div :class="`input ${icon ? 'icon' : ''} ${showSearchResults ? 'show-search' : ''}`">
    <label :for="id" v-if="icon">
      <i :class="`icon-${icon}`" />
    </label>
    <input
      type="text"
      ref="input"
      :disabled="disabled"
      :autocomplete="autocomplete ? 'on' : 'off'"
      :placeholder="placeholder"
      :value="value"
      :id="id"
      @input="emit($event.target.value)"
      @focus="toggleSearchResults"
      @keyup.enter="submit($event.target.value)"
    />
    <template v-if="!!$slots['search-results'] && showSearchResults">
      <div class="search-results nice-scrollbar" v-click-outside="hejsan">
        <slot name="search-results"></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    /**
     * Emit value to parent component
     * @param {String} value
     */
    emit(value) {
      this.$emit('input', `${value}`);
    },
    submit(value) {
      this.$emit('submit', `${value}`);
    },
    toggleSearchResults() {
      // eslint-disable-next-line
      if (!!this.$slots['search-results']) {
        this.showSearchResults = true;
      }
    },
    clear() {
      this.showSearchResults = false;
    },
    hejsan() {
      if (this.$refs.input === document.activeElement) {
        return;
      }

      this.showSearchResults = false;
    },
  },
  data() {
    return {
      showSearchResults: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.input {
  border: 1px solid #d8dae1;
  border-radius: 20px;
  position: relative;

  &.show-search {
    border-radius: 20px 20px 0 0;
  }

  label {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    width: 40px;

    i {
      font-size: 24px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  input {
    border-radius: 20px;
    line-height: 40px;
    outline: none;
    width: 100%;
  }

  &.icon {
    input {
      padding-left: 40px;
    }
  }

  .search-results {
    position: absolute;
    top: 100%;
    left: -1px;
    right: -1px;
    background-color: white;
    border: 1px solid #d8dae1;
    max-height: 400px;
    overflow: auto;
    z-index: 2;
    border-radius: 0 0 20px 20px;
    & > ul {
      & > * {
        padding: 12px 12px 12px 40px;

        &:not(:last-child) {
          border-bottom: 1px solid #d8dae1;
        }

        &.search-result-header {
          background-color: var(--table-header-bg);//#868B97;
          // color: white;
          padding: 4px 4px 4px 12px;
          border-bottom: 0;
        }
      }
    }
  }
}
</style>
